import { render, staticRenderFns } from "./documents_list.vue?vue&type=template&id=1b57971d&scoped=true&"
import script from "./documents_list.vue?vue&type=script&lang=js&"
export * from "./documents_list.vue?vue&type=script&lang=js&"
import style0 from "./documents_list.vue?vue&type=style&index=0&id=1b57971d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57971d",
  null
  
)

export default component.exports